import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import useWidgetStore from "../../store/useWidgetStore";
import { useParams } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";
export const usePoll = (formContext, options) => {
    const params = useParams();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    const { cart } = useWidgetStore();
    const { api_key, widget_id } = useSettings();
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-poll', cart.order_id], queryFn: async ({ signal }) => {
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'pollPayment', 'checkout');
            const response = await fetch(url.href, {
                signal: signal,
                method: "POST",
                headers: {
                    'Content-Type': 'application/json', // checks this header if it's a POST, while calling the method getRestData.... That's not Restful
                    'X-OAnl-csrf-protection': 'on',
                    'accept': 'application/json+ld',
                },
                body: JSON.stringify({
                    order_id: formContext.getValues("orderId") //cart.order_id
                })
            });
            return response.json();
        } }));
};
